import { getPagePath, trans, useSoyuzFlag } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import { ROLES } from '../constants';

import ContactUsHeader from './ContactUsHeader';

const InitView = () => {
  const { send } = useStateMachineContext();
  const isRedirectTenantToNewSupportSectionOn = useSoyuzFlag(
    'RedirectTenantToNewSupportSection'
  ).isOn();

  const handleRoleClick = role => {
    if (isRedirectTenantToNewSupportSectionOn) {
      window.location = getPagePath('support-contact-form');

      return;
    }

    send('SELECT', { role });
  };
  return (
    <div className="contact-us-form__fields">
      <ContactUsHeader isInvisible />
      {ROLES.map(role => (
        <Button
          dataTest={`${role}-button`}
          key={role}
          color="primary"
          size="large"
          fullWidth
          onClick={() => handleRoleClick(role)}
          className="contact-us-form__button"
        >
          {trans(`contact-us.${role}`)}
        </Button>
      ))}
      <Button
        color="primary"
        size="large"
        fullWidth
        className="contact-us-form__button"
        target="_blank"
        href={getPagePath('externals.landlord-support')}
      >
        {trans(`contact-us.landlord`)}
      </Button>
    </div>
  );
};

export default InitView;
